/**
 * Track event.
 *
 * @param {String} type Event type
 * @param {Object} data Event data
 */
export const trackEvent = (type, data) => {
  if (window.analytics?.track) {
    window.analytics.track(type, data);
  } else {
    console.log('Segment not available.', type, data); /* eslint-disable-line */
  }
};

export const identifyUser = (id, data) => {
  if (window.analytics?.identify) {
    window.analytics.identify(id, data);
  } else {
    console.log('Segment not available.', id, data); /* eslint-disable-line */
  }
};
